import { FeatureTreeAction, FeatureTreeActionType } from './action-types';
import type { IFeatureTreeState } from './types';

export const featureTreeReducerName = 'featureTreeReducer';

export const featureTreeInitialState: IFeatureTreeState = {
    tree: null,
    isLoading: false,
    hasError: false,
    errorMessage: null,
    statusCode: null,
    isGeoBlocked: false,
    isAccessDenied: false,
};

export function featureTreeReducer(
    prev: IFeatureTreeState = featureTreeInitialState,
    action: FeatureTreeAction
): IFeatureTreeState {
    switch (action.type) {
        case FeatureTreeActionType.REQUEST_FEATURE_TREE:
            return { ...prev, isLoading: true, hasError: false, errorMessage: null, statusCode: null, isGeoBlocked: false, isAccessDenied: false };

        case FeatureTreeActionType.RECEIVE_FEATURE_TREE:
            return { ...prev, isLoading: false, hasError: false, isGeoBlocked: false, isAccessDenied: false, tree: action.tree };

        case FeatureTreeActionType.ERROR_FEATURE_TREE:
            return {
                ...prev,
                isLoading: false,
                hasError: true,
                errorMessage: action.errorMessage ?? null,
                statusCode: action.statusCode ?? null,
                isGeoBlocked: action.isGeoBlocked ?? false,
                isAccessDenied: action.isAccessDenied ?? false,
                tree: null,
            };

        default:
            return prev;
    }
}
